import React from 'react';
import replaceCommaWithDot from '../../../helpers/utils/replaceCommaWithDot';
import CalculatorDropdownNew from '../../shared/CalculatorDropdownNew';
import EstimationBlock from '../templates/common/estimationBlock';
import SliderControllerBlock from '../templates/common/sliderControllerBlock';
import { termsData } from '../enums/termsData';

export default function template(context) {
    const calc = context.calc,
      model = calc.state.model,
      termBtns = (
        <>
          {model.getTerms().map((item, index) => {
            return (
              <button 
                className={`controllers-calculator-new__btn controllers-calculator-new__btn_${index + 1} ${+item === Number(model.getCreditTerm()) ? 'active' : ''}`} 
                name="loanTerm" 
                key={item} 
                onClick={calc.handleChange} 
                value={index}
              >
                {termsData[item].value} {calc.l10n(termsData[item].text)}
              </button>
            )
          })}
        </>
      );

  const selectOptions = [
    { 
      value: 'loyal_schema_five',
      label: calc.l10n("CALCULATOR_NEW_CREDIT_QUICK_CASH_SCHEMA_5")
    },
    { 
      value: 'loyal_schema_four',
      label: calc.l10n("CALCULATOR_NEW_CREDIT_QUICK_CASH_SCHEMA_4")
    },
    { 
      value: 'loyal_schema_one',
      label: calc.l10n("CALCULATOR_NEW_CREDIT_QUICK_CASH_SCHEMA_1")
    },
    { 
      value: 'loyal_schema_two',
      label: calc.l10n("CALCULATOR_NEW_CREDIT_QUICK_CASH_SCHEMA_2")
    }
  ];

  const estimationData = [
    {
      label: calc.l10n('CALCULATOR_MONTHLY_PAYMENT_NEW'),
      value: `${replaceCommaWithDot(model.getRequiredPayment().toLocaleString())} ${calc.l10n('UAH_ICON')}`,
    },
    {
      label: calc.l10n('CALCULATOR_CREDIT_SUM_NEW_DESIGN'),
      value: `${replaceCommaWithDot(model.getCreditSum().toLocaleString())} ${calc.l10n('UAH_ICON')}`,
    },
    {
      label: calc.l10n('CALCULATOR_NEW_REAL_PERCENT_RATE'),
      value: `${replaceCommaWithDot(model.getRealRate())}${calc.l10n('PERCENT')}`,
    },
    {
      label: calc.l10n('CALCULATOR_OVERPAYMENT'),
      value: `${replaceCommaWithDot(model.getOverpayment().toLocaleString())} ${calc.l10n('UAH_ICON')}`,
    },
    {
      label: calc.l10n('CALCULATOR_TOTAL_COST'),
      value: `${replaceCommaWithDot(model.getCreditCost().toLocaleString())} ${calc.l10n('UAH_ICON')}`,
    },
  ];

  return (
    <>
      <div className="calculator-new__top top-calculator-new">
        <div className="top-calculator-new__body">
          <h2 className="top-calculator-new__title">{calc.l10n('CALCULATOR_NEW_TITLE')}</h2>
          <CalculatorDropdownNew 
            name="selectedType"
            value={model.getCalculatorType()}
            onChange={calc.handleChange}
            collection={selectOptions}
          />
        </div>
      </div>
      <div className="calculator-new__bottom">
        <SliderControllerBlock
          title={calc.l10n('CALCULATOR_NEW_SUM_CONTROLLERS_TITLE')}
          inputName="creditSum"
          value={model.getCreditSum()}
          currency={calc.l10n('UAH_ICON')}
          min={model.getMinSumEdge()}
          max={model.getMaxSumEdge()}
          step={model.getSumStep()}
          currencyOffset={calc.state.valueWith}
          hiddenValueRef={calc.hiddenValue}
          onInputChange={calc.handleChangeInput}
          onInputBlur={calc.blurChangeInput}
          onRangeChange={calc.handleChange}
          showError={false}
        />
        <div className="calculator-new__controllers controllers-calculator-new">
          <div className="controllers-calculator-new__title">
            {calc.l10n('CALCULATOR_NEW_TERM_CONTROLLERS_TITLE')}
          </div>
          <div className={`controllers-calculator-new__row controllers-calculator-new__row_${model.getTerms().length}`}>
            {termBtns}
          </div>
        </div>  
        <EstimationBlock
          title={calc.l10n('CALCULATOR_NEW_ESTIMATION_TITLE')}
          items={estimationData}
        />
        {calc.props.isBtn && (
          <button className="calculator-new__order-btn" onClick={calc.props.toggleModal} id={`${calc.props.page ? calc.props.page : ''} calculator-new-button`}>
            {calc.l10n('EXPRESS_APPLICATION_APPLY_BTN')}
          </button>
        )}
        {calc.state.model.selectedType === 'loyal_schema_five' && (
          <div className='calculator-new__hint-info'>{calc.l10n("CALCULATOR_NEW_CREDIT_QUICK_CASH_HINT_INFO")}</div>
        )}
      </div>
    </>
  );
}
